import { Coord } from "../../../../../../../src/types/Interface";
import DrawAngleBgAnim from "../../../animations/DrawAngleBgAnimation";
import ReduceOpacityAnim from "../../../animations/ReduceOpacityAnimation";
import AngleBg from "../../../entities/AngleBg";


export function reduceOpacityAnim(angleBg: AngleBg): Promise<void> {
  return new Promise((resolve) => new ReduceOpacityAnim(angleBg, resolve, resolve))
}

export function drawAngleBgAnim(AngleBg: AngleBg, radian: number, coord: Coord): Promise<void> {
  AngleBg.clear();
  AngleBg.alpha = 1;
  AngleBg.startRadian = AngleBg.initialRadian;
  AngleBg.endRadian = AngleBg.initialRadian;
  
  return new Promise((resolve) => new DrawAngleBgAnim(AngleBg, radian, coord, resolve, resolve));
}